module.exports = __webpack_public_path__ + "static/img/empty_search@3x.257925c3.png";